<template>
  <div class="frontview-container">
    <div class="front-wall no-select" :style="{width: frontWallWidth + 'px'}">
      <div class="projector" ref="projector"
          :class="{mousePointer: isPJDragging,'P2-PJOffset': pjImgType === 'P2'}" @mousedown="onMouseDown" @mouseover="onMouseOver" @mouseout="onMouseOut"
          :style="{top: USTPjTop + 'px'}" >
        <img v-if="pjImgType === 'P1'" :src="require('@/assets/parts/UST/P1_front.png')" :style="{height: '55px'}"/>
        <img v-else :src="require('@/assets/parts/UST/P2_front.png')"/>
        <div class="plate-bottom-to-screen-arrow" :class="{'P2-plateBToScreen': pjImgType === 'P2'}">
          <ArrowItem :itemWidth='plateBottomToScreen' color='#008000' isVertical=true></ArrowItem>
        </div>
      </div>
      <div class="plate-top-to-ceiling-arrow" :class="{'P2-plateTToScreen': pjImgType === 'P2'}">
        <ArrowItem :itemWidth='USTPjTop' color='#008000' isVertical=true></ArrowItem>
      </div>
      <div class="screen-top-to-ceiling-arrow" :class="{'P2-screenTToCeiling': pjImgType === 'P2'}" >
        <ArrowItem :itemWidth='screenStatus.top' color='#7b68ee' isVertical=true></ArrowItem>
      </div>
      <div class="blackScreenContainer" :style="{position:'absolute',height:boardStatus.height + 'px',width:boardStatus.width + 'px',top:boardTop + 'px'}">
        <el-image class='screenImg no-select' v-if="whiteboardSupport && whiteboardStatus" fit="fill" :src="require('@/assets/parts/UST/white_board.png')" :style="{height:boardStatus.height + 'px',width:boardStatus.width + 'px'}"></el-image>
      </div>
      <div class="blackScreenContainer" :style="{height:showBlackScreenH + 'px', width: screenWidth + 'px',top:blackScreenStatus.top +'px'}">
        <el-image class="blackScreen no-select" v-if="isScreenPChange" fit="fill" :src = "require('@/assets/parts/UST/' + blackScreenImg)"
          :style="{height:blackScreenStatus.height + 'px', width: screenWidth + 'px'}">
        </el-image>
      </div>
      <div class="screen" :style="{height:screenStatus.height + 'px', width: screenWidth + 'px',top:screenStatus.top +'px'}">
        <el-image class='screenImg no-select' v-if="whiteboardSupport && whiteboardStatus" fit="fill" :src="require('@/assets/parts/UST/white_board_screen.png')" :style="{height:screenStatus.height + 'px',width: screenWidth + 'px'}"></el-image>
        <el-image class='screenImg no-select' v-else fit="fill" :src="require('@/assets/parts/UST/screen.png')" :style="{height:screenStatus.height + 'px', width: screenWidth + 'px'}"></el-image>
        <div v-if="isScreenPChange">
          <el-tooltip effect="light" offset="10" placement="top" popper-class="ust-tooltip">
            <div slot="content" class="arrow-tooltip">{{$t('T_UST_SCREEN_POSITION_FUNCTION_INFO')}}</div>
            <i class="el-icon-question"></i>
          </el-tooltip>
          <div class="arrow" @mousedown="onArrowDown"></div>
        </div>
        <img class="touchUnit no-select" v-if='(fingerTouchStatus && FTULocationState) || (fingerTouchStatus && !FTULocationState && touchInstall)' :class="{'P1-touchUnit': pjImgType === 'P1'}" :src="require('@/assets/parts/UST/' + fingerUintUrl)" :style="{position:'absolute',height:touchUnitHeight + 'px !important',top:touchUnitTop}" />
        <div class="touch-unit-val" v-if='(fingerTouchStatus && FTULocationState) || (fingerTouchStatus && !FTULocationState && touchInstall)'>{{touchUnitVal}}</div>
        <el-popover placement="bottom" width="200" trigger="manual" :content="$t('T_FINGER_TOUCH_UNIT_SHADE_MSG')" visible-arrow
          v-model="isShadowMsg">
        </el-popover>
      </div>
      <div class="screen-bottom-to-floor-arrow" :class="{'P2-screenBToFloor': pjImgType === 'P2'}">
        <ArrowItem :itemWidth='floorToBottom' color='#7b68ee' isVertical=true isBottomFix=true></ArrowItem>
      </div>
    </div>
    <img src="@/assets/parts/UST/man-front.png" class="man" :style="{height: manImgHeight + 'px'}" />
    <div class="ust-param">
      <USTItem :title="$t('T_WALLPLATE_TO_CEILING_HEIGHT')" :value="plateTopToCeilingVal" addClass="param-color"></USTItem>
      <USTItem :title="$t('T_WALLPLATE_HEIGHT')" :value="wallPlateHeightVal" addClass="param-color"></USTItem>
      <USTItem :title="$t('T_WALLPLATE_TO_SCREEN_HEIGHT')" :value="plateBottomToScreenVal" addClass="param-color"></USTItem>
    </div>
    <div class="screentop-to-ceiling">
      <USTItem :title="$t('T_SCREEN_TOP_TO_CEILING_HEIGHT')" :value="screenTopToCeilingVal" addClass="screen-to-wall-color">
      </USTItem>
    </div>

    <div class="touch-not-Install" v-if="fingerTouchStatus && !FTULocationState && !touchInstall">
      <span>{{$t('T_MESSAGE_TOUCH_INSTALL')}}</span>
    </div>

    <div class="screenbottom-to-floor">
      <USTItem :title="whiteboardSupport && whiteboardStatus ? $t('T_FLOOR_TO_BOTTOM_WHITEBOARD') : $t('T_FLOOR_TO_BOTTOM')" :value="floor2bottomVal" addClass="screen-to-wall-color"></USTItem>
    </div>
    <div class="wallplate-offset">
      <USTItem :title="$t('T_CENTER_OF_WALL_PLATE_TO_IMAGEAREA_OFFSET')" :value="wallPlateScreenOffset" addClass="wallplate-offset-color"
        isWPOffset="true">
        <img :src="require('@/assets/parts/UST/mark_'+ pjImgType +'.png')" class="ust-wallplate-offset-img"/>
      </USTItem>
    </div>
  </div>
</template>

<script>
import { mapState, mapMutations } from 'vuex'
import USTItem from './USTItem'
import ArrowItem from './USTArrow'

export default {
  components: { USTItem, ArrowItem },
  data () {
    return {
      frontWallWidth: 620,
      isPJDragging: false,
      blackScreenStatus: {},
      ratioArr: ['16:6', '21:9'],
      isShadowMsg: false,
      showBlackScreenH: 0,
      vlensShiftVal: 0
    }
  },
  props: ['manImgHeight', 'screenStatus', 'boardStatus', 'pjImgType', 'isScreenDrag', 'wallPlateH'],

  computed: {
    ...mapState([
      'graph',
      'houseInfo',
      'floor2bottom',
      'USTPjTop',
      'aspectRatio',
      'selectedModelData',
      'USTVDragFlag',
      'blackDrawData',
      'USTLenshiftV',
      'vLensShiftNow',
      'fingerTouchStatus',
      'drawData',
      'selectedLensData',
      'throwDistanceChecked',
      'whiteboardStatus',
      'FTULocationState',
      'boardStatusTop',
      'FTUT2screenT',
      'FTUT2screenTW',
      'FTUT2screenTN',
      'board2screenH',
      'touchInstall'
    ]),
    pjHeight () {
      return this.pjImgType === 'P1' ? 45 : 41 // 投影仪两绿线间的高
    },
    floor2bottomVal () {
      return this.$commonJs.changeUnit(this.floor2bottom, this.graph.unit, false, true)
    },
    boardTop () {
      return this.boardStatusTop * this.$parent.ceilingHFixed / this.houseInfo.roomH
    },
    touchUnitHeight () {
      if ((this.pjImgType === 'P2' || this.selectedModelData.modelSeries === 'Bolivia-UST') && this.whiteboardStatus && this.fingerTouchStatus && this.FTULocationState) {
        return this.FTUT2screenT * this.$parent.ceilingHFixed / this.houseInfo.roomH
      } else if ((this.pjImgType === 'P2' || this.selectedModelData.modelSeries === 'Bolivia-UST') && this.whiteboardStatus && this.fingerTouchStatus && !this.FTULocationState) {
        return this.FTUT2screenTW * this.$parent.ceilingHFixed / this.houseInfo.roomH
      } else if ((this.pjImgType === 'P2' || this.selectedModelData.modelSeries === 'Bolivia-UST') && !this.whiteboardStatus) {
        return this.FTUT2screenTN * this.$parent.ceilingHFixed / this.houseInfo.roomH
      }
    },
    touchUnitTop () {
      return '-' + this.touchUnitHeight + 'px !important'
    },
    screenWidth () {
      let width = this.graph.scrnW * this.$parent.ceilingHFixed / this.houseInfo.roomH
      return width >= this.frontWallWidth ? this.frontWallWidth : width
    },
    plateBottomToScreen () {
      return this.screenStatus.top - this.USTPjTop - this.pjHeight
    },
    plateTopToCeilingVal () {
      const value = this.graph.pjZ - this.selectedLensData.lens2mptsHeight + this.selectedLensData.mpts2wallBottomHeight - this.selectedModelData.wallHeight / 10
      return this.$commonJs.changeUnit(value, this.graph.unit, false, true)
    },
    wallPlateHeightVal () {
      return this.$commonJs.changeUnit(this.selectedModelData.wallHeight / 10, this.graph.unit, false, true)
    },
    screenTopToCeilingVal () {
      const value = this.drawData[0][0].z
      return this.$commonJs.changeUnit(value, this.graph.unit, false, true)
    },
    plateBottomToScreenVal () {
      let value = this.drawData[0][0].z - this.graph.pjZ + this.selectedLensData.lens2mptsHeight - this.selectedLensData.mpts2wallBottomHeight
      return this.$commonJs.changeUnit(value, this.graph.unit, false, true)
    },
    floorToBottom () {
      return this.floor2bottom * (this.frontWallWidth - 20) / this.houseInfo.roomH
    },
    wallPlateScreenOffset () {
      return this.$commonJs.changeUnit(this.selectedModelData.scAndwcOffset / 10, this.graph.unit, false, true)
    },
    isScreenPChange () {
      return this.ratioArr.indexOf(this.aspectRatio) !== -1
    },
    analogousVlensShift () {
      return false
    },
    fingerUintUrl () {
      let name = '120mm'
      let url = ''
      let pjImgType = (this.pjImgType === 'P2' || this.selectedModelData.modelSeries === 'Bolivia-UST') ? 'P2' : 'P1'
      if (pjImgType === 'P2') {
        if (this.aspectRatio === '16:6' || this.aspectRatio === '21:9') {
          name = '60mm'
        } else {
          name = '46mm'
        }
      }
      url = pjImgType + '_front_foot_' + name + '.png'
      return url
    },
    blackScreenImg () {
      return this.isShadowMsg ? 'line.png' : 'line_blue.png'
    },
    touchUnitVal () {
      let val
      if ((this.pjImgType === 'P2' || this.selectedModelData.modelSeries === 'Bolivia-UST') && (this.graph.unit === 'T_MILLIMETER_MM' || this.graph.unit === 'T_METRE_M') && this.whiteboardStatus && this.fingerTouchStatus && this.FTULocationState) {
        val = '90mm'
      } else if ((this.pjImgType === 'P2' || this.selectedModelData.modelSeries === 'Bolivia-UST') && (this.graph.unit === 'T_MILLIMETER_MM' || this.graph.unit === 'T_METRE_M') && this.whiteboardStatus && this.fingerTouchStatus && !this.FTULocationStat) {
        val = '100mm'
      } else if ((this.pjImgType === 'P2' || this.selectedModelData.modelSeries === 'Bolivia-UST') && !(this.graph.unit === 'T_MILLIMETER_MM' || this.graph.unit === 'T_METRE_M') && this.whiteboardStatus && this.fingerTouchStatus && this.FTULocationState) {
        val = '3.5inch'
      } else if ((this.pjImgType === 'P2' || this.selectedModelData.modelSeries === 'Bolivia-UST') && !(this.graph.unit === 'T_MILLIMETER_MM' || this.graph.unit === 'T_METRE_M') && this.whiteboardStatus && this.fingerTouchStatus && !this.FTULocationState) {
        val = '3.9inch'
      } else if (this.graph.unit === 'T_MILLIMETER_MM' || this.graph.unit === 'T_METRE_M') {
        val = '60mm'
      } else {
        val = '2.4inch'
      }
      return val
    },
    defaultRatio () {
      let ratio = this.selectedLensData.lcd.aspectRatio.split(':')
      let ratioW = ratio[0]
      let ratioH = ratio[1]
      return {ratioW, ratioH}
    },
    currentRatio () {
      let ratio = this.aspectRatio.split(':')
      let ratioW = ratio[0]
      let ratioH = ratio[1]
      return {ratioW, ratioH}
    },
    whiteboardSupport () {
      if (this.selectedModelData.whiteboardSupport) {
        return true
      } else {
        return false
      }
    }
  },
  watch: {
    blackDrawData: {
      handler (val) {
        if (this.isScreenPChange && !this.isScreenDrag) {
          const ceilingH = this.$parent.ceilingHFixed
          let blackPArr = val[0]
          let screenH = this.graph.scrnH * (this.currentRatio.ratioW * this.defaultRatio.ratioH / (this.currentRatio.ratioH * this.defaultRatio.ratioW))
          let BlackScreenH = blackPArr[3].z - blackPArr[0].z
          this.showBlackScreenH = (ceilingH * BlackScreenH) / this.houseInfo.roomH
          let height = (ceilingH * screenH) / this.houseInfo.roomH
          let top = (blackPArr[0].z * ceilingH) / this.houseInfo.roomH
          this.blackScreenStatus = {height, top}
        }
      }
    },
    aspectRatio (val) {
      if (this.isShadowMsg && val !== '16:6' && val !== '21:9') {
        this.isShadowMsg = false
      }
    },

    fingerTouchStatus (val) {
      if (this.isShadowMsg && !val) {
        this.isShadowMsg = false
      }
      if (val && this.vlensShiftVal > 0) {
        this.isShadowMsg = true
      }
    }
  },
  methods: {
    ...mapMutations([
      'SET_USTPJTOP',
      'PJZ',
      'SET_USTVDRAGFLAG',
      'SET_USTLENSHIFTV']),

    onMouseDown (e) {
      let ev = e || event
      ev.preventDefault()
      let oldY = ev.clientY
      let PJTop = this.$refs['projector'].offsetTop
      this.SET_USTVDRAGFLAG(true)
      this.isPJDragging = true
      let boardTop = this.boardStatusTop * this.$parent.ceilingHFixed / this.houseInfo.roomH
      let screenTop = this.screenStatus.top
      document.onmousemove = ev => {
        if (this.throwDistanceChecked && (!this.whiteboardSupport || !this.whiteboardStatus || (this.fingerTouchStatus && !this.FTULocationState))) return
        let e = ev || event
        let newY = e.clientY
        let moveY = newY - oldY
        if (this.throwDistanceChecked) {
          let fixedTop = this.fingerTouchStatus ? this.FTUT2screenT : this.board2screenH
          let moveLimitMin = -(screenTop - boardTop - fixedTop * this.$parent.ceilingHFixed / this.houseInfo.roomH)
          let moveLimitMax = boardTop + this.boardStatus.height - screenTop - this.screenStatus.height - this.board2screenH * this.$parent.ceilingHFixed / this.houseInfo.roomH
          moveY = this.$commonJs.checkRange(moveY, moveLimitMin, moveLimitMax)
        }
        let top = moveY + PJTop
        let pjzVal = (top * this.houseInfo.roomH) / this.$parent.ceilingHFixed + this.selectedModelData.wallHeight / 10 - this.selectedLensData.mpts2wallBottomHeight + this.selectedLensData.lens2mptsHeight
        this.PJZ(pjzVal)
      }
      document.onmouseup = ev => {
        document.onmousemove = null
        this.isPJDragging = false
        this.SET_USTVDRAGFLAG(false)
      }
    },
    onMouseOver (e) {
      if (!this.isPJDragging) {
        this.SET_USTVDRAGFLAG(true)
      }
    },
    onMouseOut () {
      if (!this.isPJDragging) {
        this.SET_USTVDRAGFLAG(false)
      }
    },
    onArrowDown (e) {
      let ev = e || event
      let oldY = ev.clientY
      let boardTop = this.boardStatusTop * this.$parent.ceilingHFixed / this.houseInfo.roomH
      let blackTop = this.blackScreenStatus.top
      let vlensShiftRange
      if (this.aspectRatio === '16:6') {
        vlensShiftRange = {min: -16.7, max: 16.7}
      } else if (this.aspectRatio === '21:9') {
        vlensShiftRange = {min: -12, max: 12}
      }
      let proportion = (this.blackScreenStatus.height - this.screenStatus.height) / 2 / this.screenStatus.height / vlensShiftRange.max * 100
      document.onmousemove = ev => {
        if (this.throwDistanceChecked && (!this.whiteboardSupport || !this.whiteboardStatus || (this.fingerTouchStatus && !this.FTULocationState))) return
        let e = ev || event
        let newY = e.clientY
        let moveY = newY - oldY
        this.vlensShiftVal = moveY / this.screenStatus.height * 100
        let black2boardBottom = boardTop + this.boardStatus.height - blackTop - this.blackScreenStatus.height - this.board2screenH * this.$parent.ceilingHFixed / this.houseInfo.roomH
        let fixedTop = (this.fingerTouchStatus ? this.FTUT2screenT : this.board2screenH) * this.$parent.ceilingHFixed / this.houseInfo.roomH
        if (this.throwDistanceChecked && black2boardBottom < 0) {
          let fixedHeight = blackTop + this.blackScreenStatus.height / 2
          let temp = (boardTop + this.boardStatus.height - fixedHeight - this.board2screenH * this.$parent.ceilingHFixed / this.houseInfo.roomH - this.screenStatus.height / 2) / proportion
          vlensShiftRange.max = temp / this.screenStatus.height * 100
        } else if (this.throwDistanceChecked && boardTop > blackTop - fixedTop) {
          let fixedHeight = blackTop + this.blackScreenStatus.height / 2
          let temp = (fixedHeight - boardTop - fixedTop - this.screenStatus.height / 2) / proportion
          vlensShiftRange.min = -temp / this.screenStatus.height * 100
        }
        if (this.vlensShiftVal <= vlensShiftRange.min) {
          this.vlensShiftVal = vlensShiftRange.min
        } else if (this.vlensShiftVal >= vlensShiftRange.max) {
          this.vlensShiftVal = vlensShiftRange.max
        }
        if (this.fingerTouchStatus && this.vlensShiftVal > 0) {
          this.isShadowMsg = true
        } else {
          this.isShadowMsg = false
        }
        this.SET_USTLENSHIFTV(this.vLensShiftNow - this.vlensShiftVal)
      }
      document.onmouseup = ev => {
        document.onmousemove = null
      }
    }
  }
}
</script>
<style scoped>
.ust-param {
  position: absolute;
  top: 73px;
  right: 1px;
}
.screentop-to-ceiling {
  position: absolute;
  top: 166px;
  left: 330px;
}
.touch-not-Install {
  position: absolute;
  top: 250px;
  left: 330px;
  width: 180px;
  background: rgba(0, 0, 0, 0.5);
  color: #fff;
  padding: 10px;
  font-size: 14px;
  z-index: 10
}

.screenbottom-to-floor {
  position: absolute;
  bottom: 120px;
  left: 330px;
}
.wallplate-offset {
  position: absolute;
  bottom: 0;
  right: 1px;
}
.man {
  position: absolute;
  bottom: 105px;
  right: 1px;
}

.front-wall {
  position: absolute;
  height: 600px;
  top: 120px;
  right: 0px;
}
.blackScreenContainer {
  overflow: hidden;

}
.projector {
  position: relative;
  left: 332px;
  z-index: 40;
  transform: translateX(-50%);
  float: left;
  width: 166px;
}
.projector:hover {
  cursor: pointer;
}
.projector.P2-PJOffset {
  left:50%;
}
.mousePointer {
  cursor: pointer;
}
.line {
  position: absolute;
  left: 55%;
  transform: translateX(-50%);
  width: 160px;
  height: 1px;
  background:#008000;
  z-index: 10
}
.screen {
  position: absolute;
  width: 400px;
  left: 50%;
  transform: translateX(-50%);
}
.screenImg {
  position: absolute !important;
}
.blackScreenContainer{
  position: absolute;
  left: 50%;
  transform: translateX(-50%);
}
.blackScreenShow{
  background-color:blue
}

.plate-top-to-ceiling-arrow{
  position: absolute;
  left: 399px;
  top: 7px;
  z-index: 10;
}
.plate-top-to-ceiling-arrow.P2-plateTToScreen{
  left: 396px;
}
.plate-bottom-to-screen-arrow{
  z-index: 20;
  position: relative;
  left: 150px;
  top: -5px;
}
.plate-bottom-to-screen-arrow.P2-plateBToScreen{
  left: 169px;
  top: -15px;
}
.screen-top-to-ceiling-arrow{
  position: absolute;
  left: 270px;
  top: 7px;
  z-index: 20
}
.screen-top-to-ceiling-arrow.P2-screenTToCeiling{
  left: 250px;
}
.screen-bottom-to-floor-arrow{
  position: absolute;
  left: 245px;
  bottom: -20px;
}
.screen-bottom-to-floor-arrow.P2-screenBToFloor{
  left: 225px;
}
.el-icon-question{
  color: black;
  position: absolute;
  left: -60px;
  top: calc(50% - 9px);
  font-size: 18px;
}
.arrow-tooltip {
  width: 200px;
}
.arrow {
  width: 34px;
  height: 95px;
  left: -25px;
  position: absolute;
  top: calc(50% - 48px);
  transform: translateX(-50%);
  background: url("../../../assets/parts/UST/btn_move.png") no-repeat;
}
.arrow:hover {
  cursor:pointer;
  background: url("../../../assets/parts/UST/btn_move_hover.png") no-repeat;
}
.pressArrowImg {
  cursor:pointer;
  background: url("../../../assets/parts/UST/btn_move_hover.png") no-repeat;
}
.wall-plate{
  position: relative;
}
.touch-unit-val {
  position: absolute;
  top: -15px;
  left: 50%;
  font-weight: bold;
  transform: translateX(40px);
}
.no-select{
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
}

</style>



// WEBPACK FOOTER //
// src/view/graph/UST/USTFrontView.vue